export const TEXT_CORE_DISPLAY_NAME = "TextCore";
